import { render, staticRenderFns } from "./TaskChangeMembers.vue?vue&type=template&id=35eb0abc&scoped=true&lang=pug&"
import script from "./TaskChangeMembers.vue?vue&type=script&lang=js&"
export * from "./TaskChangeMembers.vue?vue&type=script&lang=js&"
import style0 from "./TaskChangeMembers.vue?vue&type=style&index=0&id=35eb0abc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35eb0abc",
  null
  
)

export default component.exports